import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Divider,
  FormControlLabel,
  Grid,
  MenuItem,
  Modal,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import {
  approveReimbursement,
  getReimbursementList,
} from "_controllers/officer";
import authAxios from "setups/axios";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Toaster } from "react-hot-toast";
import moment from "moment";
import { toastMessage } from "utils/toastMessage";
import GetAppIcon from "@mui/icons-material/GetApp";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import { PageHeader, SectionCard, EmptyState, TablePager } from "_shared/ui";

const messageStyle = {
  width: "75%",
  maxHeight: "95vh",
  overflowY: "auto",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  textAlign: "left",
  letterSpacing: 1,
};

const confirmStyle = {
  width: "40%",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: "2rem",
  textAlign: "left",
  letterSpacing: 1,
};

// Map a reimbursement status to a theme semantic color for the status Chip.
const getStatusColor = (status) => {
  if (status === "Approved") return "success";
  if (status === "Rejected") return "error";
  return "warning";
};

const Main = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [remark, setRemark] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const [expenseModal, setExpenseModal] = useState(false);
  const [expenseApproveModal, setExpenseApproveModal] = useState(false);
  const [expenseRejectModal, setExpenseRejectModal] = useState(false);
  const [billPreview, setBillPreview] = useState(false);

  const [expenseData, setExpenseData] = useState();

  useEffect(async () => {
    const reimbursementList = await getReimbursementList(currentPage);
    console.log("data", reimbursementList);
    setData(reimbursementList?.data);
    setMessage(reimbursementList?.message);
    setLoading(true);
    setTotalPages(reimbursementList?.totalPage ?? 1);
    setCurrentPage(reimbursementList?.currentPage);
  }, [message, currentPage]);

  const handelUpdate = async () => {
    toastMessage(response?.data?.message, "success");
  };

  const confirmDelete = async (id) => {
    console.log("idd", id);
    const response = await authAxios()({
      url: `/api/v1/holiday/${id}`,
      method: "DELETE",
    });
    setMessage(response?.data?.message);
    toastMessage(response?.data?.message, "success");
    setDeleteDialogOpen(false);
    setDeletedItemId("");
  };

  const handleChange = (e) => {
    setValues({
      ...Values,
      [e.target.name]: e.target.value.replace(/\s+/g, " "),
    });
  };

  const handleDelete = async (id) => {
    setDeleteDialogOpen(true);
    setDeletedItemId(id);
  };

  const handleCloseDialog = () => {
    setDeleteDialogOpen(false);
    setDeletedItemId("");
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const handleRowClick = async (event, rowData) => {
    console.log("object", rowData);
    setExpenseData(rowData);
    setExpenseModal(true);
  };

  const approve = async (id) => {
    const approve = await approveReimbursement({ id, status: "Approved" });
    setMessage(approve.message);
    toastMessage(approve.message, "success");
    setExpenseApproveModal(false);
    setExpenseModal(false);
    setExpenseData();
  };

  const reject = async (id) => {
    const reject = await approveReimbursement({
      id,
      status: "Rejected",
      remark,
    });
    setMessage(reject.message);
    toastMessage(reject.message, "error");
    setExpenseRejectModal(false);
    setRemark("");
    setExpenseModal(false);
    setExpenseData();
  };

  const handleDownload = (data) => {
    console.log("download", data);
    data?.forEach((url, index) => {
      console.log("url", url);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");

      link.click();
      document.body.removeChild(link);
    });
  };

  const isDecided =
    expenseData?.status === "Approved" || expenseData?.status === "Rejected";

  return (
    <>
      <PageHeader
        title="Reimbursements"
        subtitle="Review and act on employee reimbursement requests"
      />
      {loading ? (
        <SectionCard title="Reimbursement Requests" disablePadding>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left">Date</TableCell>
                  <TableCell align="center">User ID</TableCell>
                  <TableCell align="center">Category</TableCell>
                  <TableCell align="center">Sub Category</TableCell>
                  <TableCell align="center">Amount</TableCell>
                  <TableCell align="center">Approved By</TableCell>
                  <TableCell align="center">View</TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell align="center">Attachments</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data && data?.length > 0 ? (
                  data?.map((d) => (
                    <TableRow key={d._id}>
                      <TableCell align="left">
                        {moment.utc(d?.reimbursementDate).format("YYYY-MM-DD")}
                      </TableCell>
                      <TableCell align="center">{d?.SAP_ID}</TableCell>
                      <TableCell align="center">{d?.category}</TableCell>
                      <TableCell align="center">{d?.subCategory}</TableCell>
                      <TableCell align="center">{d?.amount}</TableCell>
                      <TableCell align="center">{d?.approvedBy}</TableCell>
                      <TableCell
                        align="center"
                        onClick={(event) => handleRowClick(event, d)}
                        style={{ cursor: "pointer" }}
                      >
                        <VisibilityIcon />
                      </TableCell>
                      <TableCell align="center">
                        <Chip
                          size="small"
                          label={d?.status}
                          color={getStatusColor(d?.status)}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Button
                          onClick={() => handleDownload(d?.bills)}
                          target="_blank"
                        >
                          <GetAppIcon />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={9} sx={{ borderBottom: "none" }}>
                      <EmptyState
                        icon={ReceiptLongOutlinedIcon}
                        title="No Reimbursements Available"
                        description="Reimbursement requests will appear here once submitted."
                      />
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePager
            totalPages={totalPages}
            page={currentPage}
            onPageChange={(p) => handlePageChange(null, p)}
          />
        </SectionCard>
      ) : (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
          <CircularProgress />
        </Box>
      )}

      <Modal
        open={expenseModal}
        onClose={() => {
          setExpenseModal(false);
          setExpenseData();
        }}
      >
        <Box sx={messageStyle}>
          <Typography variant="h5" sx={{ fontWeight: 700, py: 1 }}>
            Expense Detail
          </Typography>

          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid item xs={12} md={4}>
              <SectionCard sx={{ height: "100%" }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                  Description
                </Typography>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ mt: 2 }}
                >
                  {expenseData?.description ? expenseData?.description : "NA"}
                </Typography>
              </SectionCard>
            </Grid>
            <Grid item xs={12} md={8}>
              <SectionCard sx={{ height: "100%" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 600, mb: 2 }}
                    >
                      Submitted By
                    </Typography>
                    <TextField
                      value={`${expenseData?.SAP_ID}`}
                      name="title"
                      label="Employee ID"
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 600, mb: 2 }}
                    >
                      Amount to be reimbursed
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: 500, color: "primary.main" }}
                    >
                      ₹ {`${expenseData?.amount}`}
                    </Typography>
                  </Grid>
                </Grid>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 600, mb: 2 }}
                    >
                      Submitted On
                    </Typography>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                      {moment
                        .utc(expenseData?.reimbursementDate)
                        .format("DD MMM YYYY")}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 600, mb: 2 }}
                    >
                      Status
                    </Typography>
                    <Chip
                      label={expenseData?.status}
                      color={getStatusColor(expenseData?.status)}
                    />
                  </Grid>
                </Grid>
              </SectionCard>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ mt: 0.5, mb: 2 }}>
            <Grid item xs={12} md={8}>
              <SectionCard title="Summary" sx={{ mb: 2 }}>
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Date</TableCell>
                        <TableCell>Category</TableCell>
                        <TableCell>Sub Category</TableCell>
                        <TableCell>Receipt</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>
                          {moment
                            .utc(expenseData?.reimbursementDate)
                            .format("DD MMM YYYY")}
                        </TableCell>
                        <TableCell>{expenseData?.category}</TableCell>
                        <TableCell>{expenseData?.subCategory}</TableCell>
                        <TableCell
                          onClick={(e) => handleDownload(expenseData?.bills)}
                        >
                          <GetAppIcon style={{ cursor: "pointer" }} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </SectionCard>
              <SectionCard title="Take Action">
                <Stack direction="row" spacing={2}>
                  <Button
                    variant="outlined"
                    color="error"
                    disabled={isDecided ? true : false}
                    onClick={() => setExpenseRejectModal(true)}
                  >
                    Reject
                  </Button>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={() => setExpenseApproveModal(true)}
                    disabled={isDecided ? true : false}
                  >
                    Approve
                  </Button>
                </Stack>
              </SectionCard>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  bgcolor: "action.hover",
                  height: "100%",
                  minHeight: 240,
                  p: 2,
                }}
              >
                <img
                  src={expenseData?.bills[0]}
                  alt="image"
                  style={{ width: "100%", height: "100%", objectFit: "contain" }}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      <Modal
        open={expenseApproveModal}
        onClose={() => {
          setExpenseApproveModal(false);
        }}
      >
        <Box sx={confirmStyle}>
          <Stack spacing={2}>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Sure you want to approve?
            </Typography>
            <Typography variant="body1" color="text.secondary">
              This action will approve the reimbursement.
            </Typography>
            <Stack direction="row" spacing={2} justifyContent="space-around">
              <Button
                variant="outlined"
                fullWidth
                onClick={() => setExpenseApproveModal(false)}
              >
                No, cancel
              </Button>
              <Button
                variant="contained"
                fullWidth
                onClick={() => approve(expenseData?._id)}
              >
                Yes, confirm
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={expenseRejectModal}
        onClose={() => {
          setExpenseRejectModal(false);
        }}
      >
        <Box sx={confirmStyle}>
          <Stack spacing={2}>
            <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
              Please share the reason for rejecting the reimbursement.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              This would help employees understand why their reimbursement was
              rejected.
            </Typography>
            <TextField
              sx={{ mt: 1 }}
              onChange={(e) => setRemark(e.target.value)}
              name="remark"
              value={remark}
              label="Text here"
              variant="outlined"
              fullWidth
            />
            <Stack direction="row" spacing={2} justifyContent="flex-end">
              <Button
                variant="text"
                color="inherit"
                onClick={() => setExpenseRejectModal(false)}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={() => reject(expenseData?._id)}
              >
                Submit
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

const Reimbursement = () => {
  return (
    <AccessController roles={["RO", "ZO", "ADMIN"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default Reimbursement;
